import { styled } from 'linaria/react';
import { css } from 'linaria';
import { breakpoints } from '../../../../../media';

export const SmallTextContainer = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 8px;
	max-width: 776px;
	${breakpoints.only.desktop} {
		max-width: 616px;
	}
	${breakpoints.to.tablet} {
		max-width: 100%;
	}

	& p {
		white-space: pre-wrap;
	}
`;

export const ReasonsContainer = styled.div`
	margin-top: 8px;

	& ul {
		padding-left: 21px;
		margin-top: 8px;
	}
`;

export const BenefitsContainer = styled.div`
	margin-block: 40px;

	& ul {
		padding-left: 0;
		margin-top: 24px;

		& li {
			display: flex;
			flex-direction: row;
			align-items: center;
			margin-top: 8px;
			column-gap: 6px;
			list-style: none;
		}

		& li:first-child {
			margin-top: 0;
		}
	}
`;

export const benefitsIconStyles = css`
	align-self: start;
`;

export const captionStyles = css`
	margin: 80px 0 0;
	white-space: pre-wrap;
`;

export const scheduleStyles = css`
	display: block;
	margin-top: 32px;
	line-height: 20px;
`;

export const selectedScheduleStyles = css`
	${breakpoints.only.mobile} {
		margin-top: 8px;
	}
`;
